/**
 * SetService - ImageSet関連の操作を管理
 */

import type { AppState, ImageSet, GraphOperation } from '../types'

export class SetService {
  /**
   * 新しいImageSetを作成
   */
  static createSet(name?: string, type: 'linear' | 'circular' = 'linear'): ImageSet {
    return {
      id: crypto.randomUUID(),
      type,
      name: name || `Set ${new Date().toLocaleString()}`,
      createdAt: new Date()
    }
  }

  /**
   * ImageSetを削除（関連するアイテムとノードも削除）
   */
  static *deleteSet(state: AppState, setId: string): Generator<GraphOperation> {
    // 関連するSetItemsを削除
    for (const item of Object.values(state.setItems)) {
      if (item.setId === setId) {
        yield { type: 'DELETE_ITEM', payload: { itemId: item.id } }
      }
    }
    
    // 関連するNodesを削除
    for (const node of Object.values(state.nodes)) {
      if (node.setId === setId) {
        // このノードに関連するConnectionsも削除
        for (const conn of Object.values(state.connections)) {
          if (conn.fromNodeId === node.id || conn.toNodeId === node.id) {
            yield { type: 'DELETE_CONNECTION', payload: { connectionId: conn.id } }
          }
        }
        yield { type: 'DELETE_NODE', payload: { nodeId: node.id } }
      }
    }
    
    // ImageSet自体を削除
    yield { type: 'DELETE_SET', payload: { setId } }
  }

  /**
   * SetIDから順序通りのSetItemsを取得
   */
  static getSetItems(state: AppState, setId: string) {
    return Object.values(state.setItems)
      .filter(item => item.setId === setId)
      .sort((a, b) => a.order - b.order)
  }
}